




























import Vue from 'vue';
import { OutlinedTextInput, OutlinedSelect } from '@/components/ds';
import { integerNumberFormatter } from '@/helpers/formatters';
import {
  SchoolCategoriesOptions,
  schoolCategoryFromOptionsMapper,
  schoolCategoryToOptionsMapper,
} from '@/helpers/schoolCategories';

export interface AcademicFormationFormEvent {
  schoolCategory?: string;
  year?: number;
  city?: string;
}

export default Vue.extend({
  components: { OutlinedTextInput, OutlinedSelect },
  props: {
    currentSchoolCategory: {
      type: String,
      default: '',
    },
    currentYear: {
      type: Number,
      default: undefined,
    },
    currentCity: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      schoolCategory: schoolCategoryToOptionsMapper[this.currentSchoolCategory],
      year: this.currentYear ? String(this.currentYear) : '',
      city: this.currentCity,

      schoolCategoryOptions: Object.values(SchoolCategoriesOptions),
      numberFormatter: integerNumberFormatter,
    };
  },
  methods: {
    inputHandler() {
      const event: AcademicFormationFormEvent = {
        schoolCategory: schoolCategoryFromOptionsMapper[this.schoolCategory],
        year: Number(this.year),
        city: this.city,
      };

      this.$emit('input', event);
    },
  },
});
